import React, { } from 'react';
import { Box } from "@material-ui/core"
import PropTypes from 'prop-types';
import { useStyles } from "../styles/index.style";
import CustomTooltip from '../../tooltip/Tooltip';

const ChartWrapper = ({children, title, titleColor, style, tooltipText, tooltipStyle}) => {
   const classes = useStyles();

   return (
      <Box className={classes.chart_card} style={{ ...style, display: "flex", flexDirection: "column"}}>
         <Box style={{ display: "flex", alignItems: "baseline", gap:2, margin: "0 0 10px 16px"}}>
            <Box className={classes.chart_heading} style={{ color: titleColor, width: '100%', display: "flex", justifyContent: 'space-between', gap: 5}}>
               <span>{title}</span>{tooltipText && <CustomTooltip text={tooltipText} style={{...tooltipStyle, fontSize: 16, fontColor: 'black' }} />}
            </Box>
         </Box>
         
         {children}
      </Box>
   )
}

ChartWrapper.propTypes = {
   children: PropTypes.node,
   title: PropTypes.string,
   titleColor: PropTypes.string,
   style: PropTypes.shape({
   }),
   tooltipText: PropTypes.string,
   tooltipStyle: PropTypes.shape({
   }),
 };

 ChartWrapper.defaultProps = {
   children: null,
   title: "",
   titleColor: "#58595B",
   style: {background: "white"},
   tooltipText: null,
   tooltipStyle: {color: '#B5B5B6'},
 };

export default ChartWrapper;